export const ACTION_CODE = 'EXPENSE' + '_ACTION';
